/* LMGF Market + nav. Mega menu, mobile menu, strips, AJAX filtering/sorting, load more, cart, quick view. No dependencies. */
(function () {
  if (window.__lmgfMarket) return;
  window.__lmgfMarket = true;

  var money = function (cents) {
    var c = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: c }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  };
  var parse = function (html) { return new DOMParser().parseFromString(html, 'text/html'); };

  /* ---------------- cart badge ---------------- */
  function setCount(n) {
    document.querySelectorAll('[data-lm-cart-count]').forEach(function (b) { var ch = String(b.textContent) !== String(n); b.textContent = n; b.hidden = !n; if (ch) { b.classList.remove('bump'); void b.offsetWidth; b.classList.add('bump'); } });
  }
  function refreshCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); }).catch(function () {});
  }
  document.addEventListener('lmgf:cart-updated', refreshCount);

  /* ---------------- nav ---------------- */
  function initNav() {
    var nav = document.querySelector('[data-lm-nav]');
    if (!nav) return;
    var ann = nav.querySelector('[data-lm-ann]');
    var sec = nav.closest('.shopify-section');
    function stick() {
      var a = ann ? ann.offsetHeight : 0;
      if (sec && ann) sec.style.top = (-a) + 'px';
      var h = (sec ? sec.offsetHeight : nav.offsetHeight) - a;
      document.documentElement.style.setProperty('--lmgf-sticky-offset', Math.max(0, h) + 'px');
    }
    stick(); window.addEventListener('resize', stick);

    var sub = nav.querySelector('[data-lm-subnav]');
    var open = null, timer;
    function close() {
      if (!open) return;
      open.link.setAttribute('aria-expanded', 'false'); open.link.classList.remove('on');
      open.panel.hidden = true; open = null;
    }
    function show(link) {
      var panel = document.getElementById(link.getAttribute('data-mega'));
      if (!panel) return;
      if (open && open.link === link) return;
      close();
      panel.hidden = false; link.setAttribute('aria-expanded', 'true'); link.classList.add('on');
      open = { link: link, panel: panel };
    }
    if (sub) {
      sub.querySelectorAll('[data-mega]').forEach(function (a) {
        a.addEventListener('mouseenter', function () { clearTimeout(timer); timer = setTimeout(function () { show(a); }, 90); });
        a.addEventListener('focus', function () { show(a); });
      });
      sub.querySelectorAll('li > a:not([data-mega])').forEach(function (a) { a.addEventListener('mouseenter', function () { clearTimeout(timer); close(); }); });
      sub.addEventListener('mouseleave', function () { clearTimeout(timer); timer = setTimeout(close, 160); });
      sub.addEventListener('mouseenter', function () { clearTimeout(timer); }, true);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
      var sy = window.pageYOffset; window.addEventListener('scroll', function () { if (open && Math.abs(window.pageYOffset - sy) > 80) close(); if (!open) sy = window.pageYOffset; }, { passive: true });
      document.addEventListener('click', function (e) { if (!e.target.closest('[data-lm-subnav]')) close(); });
    }

    var mm = nav.querySelector('[data-lm-mmenu]');
    var mo = nav.querySelector('[data-lm-menu-open]');
    if (mm && mo) {
      var setMM = function (on) {
        mm.hidden = !on; mo.setAttribute('aria-expanded', on ? 'true' : 'false');
        document.documentElement.style.overflow = on ? 'hidden' : '';
        if (on) { var x = mm.querySelector('[data-lm-menu-close]'); if (x) x.focus(); } else mo.focus();
      };
      mo.addEventListener('click', function () { setMM(true); });
      var so = nav.querySelector('[data-lm-search-open]');
      if (so) so.addEventListener('click', function () { setMM(true); var q = mm.querySelector('[data-lm-q]'); if (q) q.focus(); });
      mm.addEventListener('click', function (e) { if (e.target === mm || e.target.closest('[data-lm-menu-close]')) setMM(false); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !mm.hidden) setMM(false); });
    }
  }

  /* ---------------- market ---------------- */
  function initMarket() {
    var root = document.querySelector('[data-lm-market]');
    if (!root) return;
    var sectionId = root.getAttribute('data-section');

    /* toast + add to cart */
    var toast = root.querySelector('[data-toast]'), tt;
    function showToast(title, img) {
      if (!toast || window.upcartSettings) return; /* UpCart drawer already confirms the add */
      toast.querySelector('[data-toast-title]').textContent = 'Added to cart: ' + title;
      var im = toast.querySelector('[data-toast-img]');
      if (img) { im.src = img; im.hidden = false; } else im.hidden = true;
      toast.hidden = false; clearTimeout(tt);
      tt = setTimeout(function () { toast.hidden = true; }, 3800);
    }
    function hearts(el) {
      if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var r = el.getBoundingClientRect();
      for (var i = 0; i < 7; i++) {
        var h = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        h.setAttribute('viewBox', '4 5 16 16'); h.setAttribute('class', 'lm-hpop');
        h.innerHTML = '<path d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z"/>';
        h.style.left = (r.left + r.width / 2 - 8) + 'px'; h.style.top = (r.top + 4) + 'px';
        h.style.setProperty('--dx', (Math.random() * 120 - 60).toFixed(0) + 'px');
        h.style.setProperty('--dy', (-40 - Math.random() * 70).toFixed(0) + 'px');
        h.style.setProperty('--r', (Math.random() * 60 - 30).toFixed(0) + 'deg');
        h.style.animationDelay = (i * 35) + 'ms';
        document.body.appendChild(h);
        setTimeout(function (n) { n.remove(); }.bind(null, h), 1200);
      }
    }
    function addToCart(id, qty, btn, title, img) {
      if (btn) btn.disabled = true;
      return fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] })
      }).then(function (r) { return r.json(); }).then(function (res) {
        if (btn) btn.disabled = false;
        if (res.status) { alert(res.description || res.message); return; }
        if (btn) { var t = btn.textContent; btn.classList.add('done'); btn.textContent = 'Added'; setTimeout(function () { btn.classList.remove('done'); btn.textContent = t; }, 1600); }
        showToast(title, img);
        if (btn) hearts(btn);
        refreshCount();
        document.dispatchEvent(new CustomEvent('lmgf:cart-updated'));
      }).catch(function () { if (btn) btn.disabled = false; });
    }

    /* quick view */
    var qvo = root.querySelector('[data-qvo]');
    var qv = { v: null, qty: 1, title: '', img: '' }, lastFocus;
    function closeQV() { qvo.hidden = true; document.documentElement.style.overflow = ''; if (lastFocus) lastFocus.focus(); }
    function openQV(handle, card) {
      fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
        var v = p.variants.find(function (x) { return x.available; }) || p.variants[0];
        qv.v = v; qv.qty = 1; qv.title = p.title;
        qv.img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=900' : '';
        qvo.querySelector('[data-qv-img]').src = qv.img;
        qvo.querySelector('[data-qv-img]').alt = p.title;
        qvo.querySelector('[data-qv-title]').textContent = p.title;
        var br = card && card.querySelector('.brand'), qb = qvo.querySelector('[data-qv-brand]');
        qb.textContent = br ? br.textContent : p.vendor; qb.href = br ? br.getAttribute('href') : '#';
        qvo.querySelector('[data-qv-cat]').textContent = p.type || '';
        var tmp = document.createElement('div'); tmp.innerHTML = p.description || '';
        var d = (tmp.textContent || '').replace(/\s+/g, ' ').trim();
        qvo.querySelector('[data-qv-desc]').textContent = d.length > 180 ? d.slice(0, 177) + '…' : d;
        qvo.querySelector('[data-qv-price]').textContent = money(v.price);
        var cmp = qvo.querySelector('[data-qv-cmp]');
        if (v.compare_at_price > v.price) { cmp.textContent = money(v.compare_at_price); cmp.hidden = false; } else cmp.hidden = true;
        qvo.querySelector('[data-qty-val]').textContent = '1';
        qvo.querySelectorAll('[data-qv-link]').forEach(function (a) { a.href = p.url || ('/products/' + p.handle); });
        var add = qvo.querySelector('[data-qv-add]');
        add.disabled = !v.available;
        add.textContent = v.available ? (p.variants.length > 1 ? 'Add ' + v.title : 'Add to cart') : 'Sold out';
        qvo.hidden = false; document.documentElement.style.overflow = 'hidden';
        qvo.querySelector('[data-qx]').focus();
      });
    }
    if (qvo) {
      qvo.addEventListener('click', function (e) { if (e.target === qvo || e.target.closest('[data-qx]')) closeQV(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !qvo.hidden) closeQV(); });
      qvo.querySelectorAll('[data-qty]').forEach(function (b) {
        b.addEventListener('click', function () { qv.qty = Math.max(1, qv.qty + Number(b.getAttribute('data-qty'))); qvo.querySelector('[data-qty-val]').textContent = qv.qty; });
      });
      qvo.querySelector('[data-qv-add]').addEventListener('click', function (e) {
        if (!qv.v) return;
        addToCart(qv.v.id, qv.qty, e.currentTarget, qv.title, qv.img).then(closeQV);
      });
    }

    /* scroll arrows */
    root.addEventListener('click', function (e) {
      var a = e.target.closest('[data-scroll]');
      if (a) {
        var sc = a.parentNode.querySelector('[data-scroller]');
        if (sc) sc.scrollBy({ left: Number(a.getAttribute('data-scroll')) * sc.clientWidth * 0.85, behavior: 'smooth' });
        return;
      }
      var b = e.target.closest('[data-add]');
      if (b) { e.preventDefault(); addToCart(b.getAttribute('data-add'), 1, b, b.getAttribute('data-title'), b.getAttribute('data-img')); return; }
      var q = e.target.closest('[data-qv]');
      if (q && qvo) { e.preventDefault(); lastFocus = q; openQV(q.getAttribute('data-qv'), q.closest('.card')); }
    });

    /* strips (Best Sellers, New Arrivals) */
    function loadStrip(sc) {
      if (sc.__lm) return; sc.__lm = 1;
      fetch(sc.getAttribute('data-strip-src')).then(function (r) { return r.text(); }).then(function (html) {
        var cards = parse(html).querySelectorAll('.card');
        if (!cards.length) { var s = sc.closest('.sec'); if (s) s.hidden = true; return; }
        sc.innerHTML = '';
        cards.forEach(function (c) { sc.appendChild(document.importNode(c, true)); });
        arrows(sc);
      }).catch(function () { var s = sc.closest('.sec'); if (s) s.hidden = true; });
    }
    /* arrows hide at scroll ends */
    function arrows(sc) {
      var w = sc.parentNode, l = w.querySelector('.arrow.l'), r = w.querySelector('.arrow.r');
      if (!l || !r) return;
      var u = function () { l.disabled = sc.scrollLeft < 8; r.disabled = sc.scrollLeft + sc.clientWidth >= sc.scrollWidth - 8; };
      sc.addEventListener('scroll', u, { passive: true }); u();
    }
    root.querySelectorAll('.tiles[data-scroller]').forEach(arrows);
    var strips = root.querySelectorAll('[data-strip-src]');
    if ('IntersectionObserver' in window) {
      var so = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { so.unobserve(e.target); loadStrip(e.target); } }); }, { rootMargin: '400px 0px' });
      strips.forEach(function (sc) { so.observe(sc); });
    } else strips.forEach(loadStrip);
    /* reveal on scroll */
    if ('IntersectionObserver' in window) {
      var ro = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); ro.unobserve(e.target); } }); }, { threshold: .15 });
      root.querySelectorAll('[data-reveal]').forEach(function (el) { ro.observe(el); });
    } else root.classList.add('no-io');

    /* ---------- AJAX filtering + sorting ---------- */
    var all = root.querySelector('[data-lm-all]');
    var shut = {};
    var drawerWasOpen = false;

    function cleanUrl(u) {
      var url = new URL(u, location.origin);
      url.searchParams.delete('section_id'); url.searchParams.delete('page');
      return url;
    }
    function load(u, opts) {
      opts = opts || {};
      var url = new URL(u, location.origin);
      url.hash = '';
      var fetchUrl = new URL(url); fetchUrl.searchParams.set('section_id', sectionId);
      var res = all.querySelector('[data-results]');
      if (res) res.classList.add('loading');
      var unload = function () { var r2 = all.querySelector('[data-results]'); if (r2) r2.classList.remove('loading'); };
      var form = all.querySelector('[data-filters]');
      drawerWasOpen = !!(form && form.classList.contains('open'));
      return fetch(fetchUrl.toString()).then(function (r) { return r.text(); }).then(function (html) {
        var next = parse(html).querySelector('[data-lm-all]');
        if (!next) { location.href = url.toString(); return; }
        if (opts.append) {
          var grid = all.querySelector('[data-grid]');
          next.querySelectorAll('[data-grid] .card').forEach(function (c) { grid.appendChild(document.importNode(c, true)); });
          var m = all.querySelector('[data-more]'), nm = next.querySelector('[data-more]');
          if (m && nm) m.replaceWith(document.importNode(nm, true));
          unload();
          return;
        }
        all.innerHTML = next.innerHTML;
        bindAll();
        if (drawerWasOpen) setDrawer(true);
        if (!opts.noPush) history.pushState({ lm: 1 }, '', url.pathname + url.search + '#all');
        if (opts.scroll) {
          var y = all.getBoundingClientRect().top + window.pageYOffset - 150;
          if (window.pageYOffset > y) window.scrollTo({ top: y, behavior: 'smooth' });
        }
      }).catch(function () { location.href = url.toString(); });
    }
    window.addEventListener('popstate', function () { load(location.href, { noPush: true }); });

    function formUrl(form) {
      var fd = new FormData(form), p = new URLSearchParams();
      fd.forEach(function (v, k) { if (k.indexOf('lm-') === 0) return; if (String(v).trim() !== '') p.append(k, v); });
      var action = new URL(form.getAttribute('action'), location.origin);
      return action.pathname + (p.toString() ? '?' + p.toString() : '');
    }
    function withQuery(path) {
      var cur = new URLSearchParams(location.search); cur.delete('page');
      var u = new URL(path, location.origin);
      return u.pathname + (cur.toString() ? '?' + cur.toString() : '');
    }

    function setDrawer(on) {
      var f = all.querySelector('[data-filters]');
      if (!f) return;
      var mobile = !window.matchMedia('(min-width: 1100px)').matches;
      f.classList.toggle('open', on);
      f.setAttribute('role', on && mobile ? 'dialog' : '');
      document.documentElement.style.overflow = on && mobile ? 'hidden' : '';
    }

    function bindAll() {
      var form = all.querySelector('[data-filters]');
      /* sort */
      var sb = all.querySelector('[data-sort-btn]'), sm = all.querySelector('[data-sort-menu]');
      if (sb && sm) {
        sb.addEventListener('click', function () { var o = sm.hidden; sm.hidden = !o; sb.setAttribute('aria-expanded', o ? 'true' : 'false'); });
        sm.addEventListener('click', function (e) {
          var o = e.target.closest('[data-sort]'); if (!o) return;
          var url = cleanUrl(location.href); url.searchParams.set('sort_by', o.getAttribute('data-sort'));
          load(url.toString(), { scroll: true });
        });
      }
      if (!form) return;
      /* collapsible sections */
      form.querySelectorAll('.fsec').forEach(function (s) {
        var k = s.getAttribute('data-fsec'), btn = s.querySelector(':scope > button'), body = s.querySelector('.fopts');
        var apply = function () { var off = !!shut[k]; btn.classList.toggle('shut', off); btn.setAttribute('aria-expanded', off ? 'false' : 'true'); body.hidden = off; };
        apply();
        btn.addEventListener('click', function () { shut[k] = !shut[k]; apply(); });
      });
      /* drawer */
      var od = all.querySelector('[data-drawer-open]'); if (od) od.addEventListener('click', function () { setDrawer(true); });
      var cd = form.querySelector('[data-drawer-close]'); if (cd) cd.addEventListener('click', function () { setDrawer(false); });
      /* checkbox filters auto-apply */
      form.addEventListener('change', function (e) {
        var t = e.target;
        if (t.matches('[data-href]')) { location.href = t.getAttribute('data-href'); return; }
        if (t.matches('[data-taglink]')) { load(withQuery(t.getAttribute('data-taglink'))); return; }
        if (t.matches('[data-under]')) {
          var mn = form.querySelector('[data-pmin]'), mx = form.querySelector('[data-pmax]');
          if (mn && mx) { mn.value = ''; mx.value = t.checked ? t.getAttribute('data-under') : ''; }
          load(formUrl(form)); return;
        }
        if (t.matches('input[type=checkbox][name]')) { load(formUrl(form)); return; }
        if (t.matches('[data-pmin],[data-pmax]')) { syncRange(); load(formUrl(form)); }
      });
      form.addEventListener('submit', function (e) { e.preventDefault(); var mobileOpen = form.classList.contains('open') && !window.matchMedia('(min-width: 1100px)').matches; load(formUrl(form), { scroll: true }).then(function () { if (mobileOpen) setDrawer(false); }); if (mobileOpen) setDrawer(false); });
      /* price range */
      var pr = form.querySelector('[data-price]');
      function syncRange() {
        if (!pr) return;
        var cap = Number(pr.getAttribute('data-cap')) || 100;
        var a = Number(form.querySelector('[data-pmin]').value || 0), b = form.querySelector('[data-pmax]').value === '' ? cap : Number(form.querySelector('[data-pmax]').value);
        pr.querySelector('[data-rmin]').value = a; pr.querySelector('[data-rmax]').value = b;
        var f = pr.querySelector('[data-pfill]');
        if (f) { f.style.left = (a / cap * 100) + '%'; f.style.right = (100 - b / cap * 100) + '%'; }
        pr.querySelectorAll('[data-preset]').forEach(function (x) {
          var r = x.getAttribute('data-preset').split('-'), ra = Number(r[0]), rb = r[1] === '' ? cap : Number(r[1]);
          x.classList.toggle('on', ra === a && rb === b && (a > 0 || b < cap));
        });
      }
      if (pr) {
        syncRange();
        var rt;
        pr.querySelectorAll('[data-rmin],[data-rmax]').forEach(function (r) {
          r.addEventListener('input', function () {
            var cap = Number(pr.getAttribute('data-cap'));
            var a = Number(pr.querySelector('[data-rmin]').value), b = Number(pr.querySelector('[data-rmax]').value);
            if (a > b) { if (r.matches('[data-rmin]')) a = b; else b = a; }
            form.querySelector('[data-pmin]').value = a > 0 ? a : '';
            form.querySelector('[data-pmax]').value = b < cap ? b : '';
            syncRange();
            clearTimeout(rt); rt = setTimeout(function () { load(formUrl(form)); }, 450);
          });
        });
        pr.querySelectorAll('[data-preset]').forEach(function (x) {
          x.addEventListener('click', function () {
            var r = x.getAttribute('data-preset').split('-');
            var on = x.classList.contains('on');
            form.querySelector('[data-pmin]').value = on || r[0] === '0' ? '' : r[0];
            form.querySelector('[data-pmax]').value = on ? '' : r[1];
            syncRange(); load(formUrl(form));
          });
        });
      }
      /* brand search + show all */
      var bw = form.querySelector('[data-brands]');
      if (bw) {
        var bq = bw.querySelector('[data-bq]'), more = bw.querySelector('[data-brand-more]'), expanded = false;
        var applyB = function () {
          var q = (bq.value || '').trim().toLowerCase();
          bw.querySelectorAll('label.opt').forEach(function (l) {
            var match = !q || l.textContent.toLowerCase().indexOf(q) > -1;
            var extra = l.hasAttribute('data-bmore') && !expanded && !q;
            l.hidden = !match || extra;
          });
          if (more) { more.hidden = !!q; more.textContent = expanded ? 'Show fewer brands' : more.textContent.replace('Show fewer brands', 'Show all brands'); }
        };
        bq.addEventListener('input', applyB);
        if (more) { var lbl = more.textContent; more.addEventListener('click', function () { expanded = !expanded; more.textContent = expanded ? 'Show fewer brands' : lbl; applyB(); }); }
      }
    }

    if (all) {
      bindAll();
      all.addEventListener('click', function (e) {
        var a = e.target.closest('a[data-ajax], a[data-clear]');
        if (a) { e.preventDefault(); load(a.href, { scroll: true }); return; }
        var t = e.target.closest('a[data-taglink]');
        if (t) { e.preventDefault(); load(withQuery(t.getAttribute('data-taglink')), { scroll: true }); return; }
        var m = e.target.closest('[data-load-more]');
        if (m) {
          e.preventDefault(); m.textContent = 'Loading…'; m.setAttribute('aria-busy', 'true');
          var u = new URL(m.href, location.origin);
          load(u.toString(), { append: true, noPush: true });
        }
      });
      document.addEventListener('click', function (e) {
        var sm = all.querySelector('[data-sort-menu]'), sb = all.querySelector('[data-sort-btn]');
        if (sm && !sm.hidden && !e.target.closest('.sortwrap')) { sm.hidden = true; sb.setAttribute('aria-expanded', 'false'); }
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { var f = all.querySelector('[data-filters].open'); if (f) setDrawer(false); } });
    }
    /* View all links on strips sort the grid in place */
    root.querySelectorAll('[data-sort-link]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (!all) return;
        e.preventDefault();
        var url = cleanUrl(location.href); url.searchParams.set('sort_by', a.getAttribute('data-sort-link'));
        load(url.toString()).then(function () { all.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
      });
    });
  }

  function init() { initNav(); initMarket(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* LMGF search: on-brand instant results (Shopify predictive search). Inputs have no name="q" so third-party search popups leave them alone. */
(function () {
  if (window.__lmgfSearch) return;
  window.__lmgfSearch = true;
  var money = function (v) { var n = Number(v); if (isNaN(n)) return v; if (String(v).indexOf('.') === -1 && n > 999) n = n / 100; return '$' + n.toFixed(2); };
  var esc = function (s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  function go(q) { location.href = '/search?type=product&q=' + encodeURIComponent(q); }
  function init() {
    document.querySelectorAll('form[data-lm-search]').forEach(function (form) {
      var input = form.querySelector('[data-lm-q]');
      if (!input) return;
      form.style.position = form.style.position || 'relative';
      var box = document.createElement('div');
      box.className = 'lm-sugg'; box.hidden = true; box.setAttribute('role', 'listbox');
      box.id = input.id + '-sugg';
      input.setAttribute('aria-controls', box.id); input.setAttribute('aria-autocomplete', 'list');
      form.appendChild(box);
      var t, last = '', ctrl;
      form.addEventListener('submit', function (e) { e.preventDefault(); var q = input.value.trim(); if (q) go(q); });
      function close() { box.hidden = true; }
      input.addEventListener('input', function () {
        clearTimeout(t);
        var q = input.value.trim();
        if (q.length < 2) { close(); return; }
        t = setTimeout(function () {
          if (q === last && !box.hidden) return;
          last = q;
          if (ctrl) ctrl.abort();
          ctrl = window.AbortController ? new AbortController() : null;
          fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last', ctrl ? { signal: ctrl.signal } : {})
            .then(function (r) { return r.json(); }).then(function (d) {
              var res = (d && d.resources && d.resources.results) || {};
              var ps = res.products || [], cs = (res.collections || []).slice(0, 3);
              var h = '';
              if (cs.length) h += '<div class="lm-sugg-h">Categories</div>' + cs.map(function (c) { return '<a class="lm-sugg-c" href="' + esc(c.url) + '">' + esc(c.title) + '</a>'; }).join('');
              if (ps.length) h += '<div class="lm-sugg-h">Products</div>' + ps.map(function (p) {
                return '<a class="lm-sugg-p" role="option" href="' + esc(p.url) + '">' + (p.image ? '<img src="' + esc(p.image) + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" loading="lazy">' : '<span class="ph"></span>') +
                  '<span class="tx"><small>' + esc(p.vendor) + '</small><b>' + esc(p.title) + '</b></span><span class="pr">' + money(p.price) + '</span></a>';
              }).join('');
              h += ps.length || cs.length ? '<a class="lm-sugg-all" href="/search?type=product&q=' + encodeURIComponent(q) + '">See all results for "' + esc(q) + '"</a>' : '<p class="lm-sugg-none">No matches for "' + esc(q) + '". Try a brand or a food.</p>';
              box.innerHTML = h; box.hidden = false;
            }).catch(function () {});
        }, 180);
      });
      input.addEventListener('keydown', function (e) {
        var items = [].slice.call(box.querySelectorAll('a'));
        var i = items.indexOf(document.activeElement);
        if (e.key === 'ArrowDown' && items.length && !box.hidden) { e.preventDefault(); items[0].focus(); }
        if (e.key === 'Escape') close();
      });
      box.addEventListener('keydown', function (e) {
        var items = [].slice.call(box.querySelectorAll('a')), i = items.indexOf(document.activeElement);
        if (e.key === 'ArrowDown') { e.preventDefault(); (items[i + 1] || items[i]).focus(); }
        if (e.key === 'ArrowUp') { e.preventDefault(); if (i <= 0) input.focus(); else items[i - 1].focus(); }
        if (e.key === 'Escape') { close(); input.focus(); }
      });
      document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
      input.addEventListener('focus', function () { if (box.innerHTML && input.value.trim().length > 1) box.hidden = false; });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
